import Socket from "./public";

/** event -> Set<callback> */
const listenerMap = new Map();
/** 已向底层 Socket 注册 fan-out 的 event */
const socketRegistered = new Set();

/**
 * 同一 kline@symbol,interval 允许多路监听（TradingView + Convert 价格文案等）
 * 底层仅注册一次 Socket.addChannel，避免后注册覆盖先注册。
 */
export function addKlineChannel(event, callback) {
  if (!event || typeof callback !== "function") {
    return () => {};
  }

  if (!listenerMap.has(event)) {
    listenerMap.set(event, new Set());
  }
  listenerMap.get(event).add(callback);

  if (!socketRegistered.has(event)) {
    socketRegistered.add(event);
    Socket.addChannel({ event }, (data) => {
      const listeners = listenerMap.get(event);
      if (!listeners) return;
      listeners.forEach((fn) => {
        try {
          fn(data);
        } catch (err) {
          console.warn("【klineChannel】listener error", err);
        }
      });
    });
  }

  return () => removeKlineChannel(event, callback);
}

export function removeKlineChannel(event, callback) {
  const listeners = listenerMap.get(event);
  if (!listeners) return;

  listeners.delete(callback);
  if (listeners.size > 0) return;

  listenerMap.delete(event);
  if (socketRegistered.has(event)) {
    socketRegistered.delete(event);
    Socket.removeChannel({ event });
  }
}
